/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { CardContent, ICardContentProps } from "../../Card";

export interface IFieldCardContentProps extends ICardContentProps {
	className?: string;
}

export const FieldCardContent: React.FC<IFieldCardContentProps> = ({ className, children, ...props }) => {
	const baseClass = BEM("edt-field-card-content");

	if (className) {
		baseClass.add(className);
	}

	return (
		<CardContent className={baseClass.toClassName()} {...props}>
			{children}
		</CardContent>
	);
};
